import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";
import { parseWishlistSearch } from "./lib/wishlistSearch";

const customersIndex = lazyWithRetry(() => import("./routes/index"));
const customerCreate = lazyWithRetry(() => import("./routes/create"));
const customerDetail = lazyWithRetry(() => import("./routes/[id]"));
const wishlists = lazyWithRetry(() => import("./routes/wishlists"));

const customersIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/customers",
  beforeLoad: () => ({
    breadcrumbs: [{ label: "Dashboard", to: "/" }, { label: "Customers" }],
  }),
  component: () =>
    renderProtectedRoute(customersIndex, { requirePerms: ["customers:read"] }),
});

const customerCreateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/customers/create",
  component: () =>
    renderProtectedRoute(customerCreate, { requirePerms: ["customers:write"] }),
});

const customerDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/customers/$id",
  component: () =>
    renderProtectedRoute(customerDetail, { requirePerms: ["customers:read"] }),
});

const wishlistsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/customers/wishlists",
  validateSearch: parseWishlistSearch,
  component: () =>
    renderProtectedRoute(wishlists, { requirePerms: ["customers:read"] }),
});

export const customersRouteTree = [
  customersIndexRoute,
  customerCreateRoute,
  customerDetailRoute,
  wishlistsRoute,
];
